var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"portrait",style:({ width: _vm.size + 'px', height: _vm.size + 'px' })},[_c('img',{staticClass:"photo",attrs:{"src":_vm.photo,"alt":"","draggable":"false"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }